import { render, staticRenderFns } from "./EntityAutocomplete.vue?vue&type=template&id=4b2f9f89&scoped=true"
import script from "./EntityAutocomplete.vue?vue&type=script&lang=js"
export * from "./EntityAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f9f89",
  null
  
)

export default component.exports